import React from 'react';
import { Col } from 'reactstrap';

import SectionTitle from './SectionTitle';
import SearchButton from './SearchButton';
import OrderFrequencyChart from './OrderFrequencyChart';
import OrderFrequencyScatterChart from './OrderFrequencyScatterChart';

const OrderFrequencyDetail = props => {

    const { colContainerStyle, mainItem, flexSpace, chartContainer } = styles;

    return (
        <Col style={colContainerStyle} sm={props.colSize}>
            <div style={props.insightType==="restaurant" ? {height: '207px', ...mainItem} : {height: '173px', ...mainItem}}>
                <div style={flexSpace}>
                    <SectionTitle title={props.sectionTitle} titleAddition={props.sectionTitleAddition} />
                    {(props.element !== 'ordersCount' && props.element !== 'ordersTotal') ?
                    <SearchButton onClick={props.toggleModal} /> : null}
                </div>
                <div className="thinScrollbar" style={props.insightType==="restaurant" ? {height: '169px', ...chartContainer} : {height: '130px', ...chartContainer}}>
                    <OrderFrequencyScatterChart
                        period={props.period}
                        content={props.content}
                        element={props.element}
                        week={props.week}
                        // height={130}
                        // width={315}
                    />
                </div>
            </div>
        </Col>

    );
}

export default OrderFrequencyDetail;

const styles = {
    colContainerStyle: {
        padding: '10px'
    },
    mainItem: {
        position: 'relative',
        //height: '170px',
        backgroundColor: 'white',
    },
    flexSpace: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px'
    },
    chartContainer: {
        //height: '130px',
        overflow: 'auto'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderFrequencyDetail.js